<div class="wave-container">
    <nav id="navigation" class="navbar navbar-expand-lg">
        <div class="container-fluid">
            <span class="navbar-brand mb-0" id="argus-logo">
                <img src="assets/images/camera.png" alt="logo-brand-argus">
                <div id="brand">
                    <span class="brand-text text-shadow">Analog</span>
                    <span class="brand-subtext text-shadow">argus</span>
                </div>
            </span>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <img src="assets/images/hamburger.svg" alt="hamburger" height="50px">
            </button>
            <div class="collapse justify-content-end navbar-collapse" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item text-shadow hover rounded">
                        <a class="nav-link text-white fs-5" aria-current="page" routerLink='/'>Accueil</a>
                    </li>
                    <li class="nav-item text-shadow hover rounded">
                        <a class="nav-link text-white fs-5" routerLink="references">Modèles</a>
                    </li>
                    <li class="nav-item text-shadow hover rounded">
                        <a class="nav-link text-white fs-5" href="#search">Recherche</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</div>